import { useService } from 'envoc-request';
import { AccountService } from 'api';

export default function XsrfToken() {
  useService(AccountService.getLoggedInUserDetails);

  return null;
}
